const clearUrlParams = () => {
  if (typeof window !== 'undefined') {
    window.history.replaceState({}, document.title, window.location.pathname);
  }
};

export default clearUrlParams;
